//@ts-nocheck 

import { LorbizField } from "./field";

// import { MNField } from "./field";
// import { MetaNode } from "../../Browser/Objects/metanode";

// export class MtTextField extends MetaNode<MtTextField> {    
// }

const inputMap = new WeakMap<LorbizField, HTMLInputElement | HTMLTextAreaElement>();


export var thisclass = {
    onload: function () {
        window.textAreaAdd = 2;
    },

    textfield: function (args: { value: string; pwd: any; id: any; }) {

        var inputElement = window.document.createElement("input");
        inputElement.type = "text";

        //const mtField = MNField.get(oos(args.id));       


        inputElement.pendsend = false;
        inputElement.value = args.value;
        inputElement.classList.add("-input");

        if (args.pwd) inputElement.type = "password";
        var field = (window as any).oos(args.id) as LorbizField;
        inputMap.set(field, inputElement);
        field.lrinput = inputElement;

        
        // mtField.baseElement.lrinput = inputElement;
        // mtField.payloadTarget.appendChild(inputElement);

        field.appendChild(inputElement);
        var lastValue = inputElement.value;
        function sendValue() {
            if (inputElement.value !== lastValue) {
                lastValue = inputElement.value;
                window.jsE(args.id, inputElement.value);
            }
        }

        //add event on change, lost focus, enter and tab
        inputElement.addEventListener('change', sendValue);
        inputElement.addEventListener('blur', sendValue);
        inputElement.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === 'Tab') {
                sendValue();
            }
        });
    },

    focus: function (id: any) {
        window.setTimeout(function () {
            let field = (window as any).oos(id) as LorbizField;
            let input = inputMap.get(field)!;
            input.select();
            input.focus();
        },
            25);
    },


    mediumtextfield: function (args: { value: string; rw: string; rows: number; id: any; }) {
        var observe;
        if (window.attachEvent) {
            observe = function (element: { attachEvent: (arg0: string, arg1: any) => void; }, event: string, handler: any) {
                element.attachEvent('on' + event, handler);
            };
        } else {
            observe = function (element: { addEventListener: (arg0: any, arg1: any, arg2: boolean) => void; }, event: any, handler: any) {
                element.addEventListener(event, handler, false);
            };
        }

        var input = window.document.createElement("textarea");
        input.value = args.value;

        var resize = function () {
            input.style.height = 'auto';
            input.style.height = (input.scrollHeight + 8) + 'px';
        };

        var delayedResize = function () { window.setTimeout(resize, 1); };
        observe(input, 'change', resize);
        observe(input, 'cut', delayedResize);
        observe(input, 'paste', delayedResize);
        observe(input, 'drop', delayedResize);
        observe(input, 'keydown', delayedResize);

        input.className = "lorbizfieldinput textarea";
        input.pendsend = false;

        //input.rows = args.rw;
        input.setAttribute("rows", args.rw);

        if (args.rows) input.rows = args.rows;
        input.style.resize = "none";
        //input.style.maxHeight = (args.rw * 1.65) + "em";

       let field = (window as any).oos(args.id) as LorbizField;
       inputMap.set(field, input);

        window.afterRender.push(function () {
            delayedResize();
        });

        if (field.captionCell) field.captionCell.style.verticalAlign = "top";       
        field.appendChild(input);
        input.lastValue = "";
        input.onchange = function () {
            if (input.value !== input.lastValue) {
                input.lastValue = input.value;
                window.jsE(args.id, input.value);
            }
        };



        input.addEventListener('keydown',
            function (e) {
                if (e.key === 'Enter') window.jsE(args.id, input.value);
            });



        thisclass.setKeyStrokeEvent(args.id, 1000);

    },

    setValue: function (id: any, value: any) {
        let field = (window as any).oos(id) as LorbizField;
        let input = inputMap.get(field)!;
        input.lastValue = value;
        input.value = value;
    },

    setKeyStrokeEvent: function (id: any, delay: number | undefined) {
        var input = inputMap.get((window as any).oos(id));
        if (input.onkeyup !== null) return;
        input.addEventListener("keyup",
            function () {
                if (typeof input.lrTimer !== "undefined") window.clearInterval(input.lrTimer);
                input.lrTimer = window.setTimeout(function () {
                    var element = window.oos(id);
                    if (element && element.lrinput) window.jsE(id, element.lrinput.value);
                },
                    delay);
                input.pendsend = true;
            });
    }
}

